import { createSelectorCreator, defaultMemoize } from 'reselect';
import { isEqual } from '@comeon/utility';
import { REDUCER_NAME } from './constants';
// import { Item } from '../types';
import { Item } from '../../item-detail-view/item-detail-view-types';

// export function selectPromotionsIsPolling(state: RootState): boolean;
// export function selectPromotionsHydrated(state: RootState): boolean;
// export function selectPromotionsItemsMemoized(state: RootState): Item[];
// export function selectIsThunderbiteTabOpen(state: RootState): boolean;
// export function selectThunderbiteItems(state: RootState): Item[];
// export function selectThunderbiteHydrated(state: RootState): boolean;
// export function selectThunderbiteIsPolling(state: RootState): boolean;
// export function selectSelectedPromotionsSplitCategory(state: RootState): string;
// export function selectPromotionsIsAvailableForUser(state: RootState): boolean;

type AllPromotionState = {
	promotions: {
		items: Item[];
		isHydrated: boolean;
		isPolling: boolean;
		error: string;
		availabilityHydrated: boolean;
		isAvailableForUser: boolean;
		isPollingAvailability: boolean;
		selectedPromotionsSplitCategory: string;
		thunderbite: {
			isThunderbiteTabOpen: boolean;
			items: Item[];
			isHydrated: boolean;
			isPolling: boolean;
			error: string;
		};
	};
};

// Selectors
export const selectPromotionsItems = (state: AllPromotionState) => state[REDUCER_NAME]?.items;
export const selectPromotionsHydrated = (state: AllPromotionState) => state[REDUCER_NAME]?.isHydrated;
export const selectPromotionsIsPolling = (state: AllPromotionState) => state[REDUCER_NAME]?.isPolling;
export const selectPromotionsError = (state: AllPromotionState) => state[REDUCER_NAME]?.error;
export const selectPromotionsIsAvailableForUserHydrated = (state: AllPromotionState) =>
	state[REDUCER_NAME]?.availabilityHydrated;
export const selectPromotionsIsAvailableForUser = (state: AllPromotionState) => state[REDUCER_NAME]?.isAvailableForUser;
export const selectIsPollingAvailability = (state: AllPromotionState) => state[REDUCER_NAME]?.isPollingAvailability;
export const selectSelectedPromotionsSplitCategory = (state: AllPromotionState) =>
	state[REDUCER_NAME]?.selectedPromotionsSplitCategory;
const createDeepEqualSelector = createSelectorCreator(defaultMemoize, isEqual);
export const selectPromotionsItemsMemoized = createDeepEqualSelector(selectPromotionsItems, items => {
	return items;
});
export const selectIsThunderbiteTabOpen = (state: AllPromotionState) =>
	state[REDUCER_NAME]?.thunderbite?.isThunderbiteTabOpen;
export const selectThunderbiteItems = (state: AllPromotionState) => state[REDUCER_NAME]?.thunderbite?.items;
export const selectThunderbiteHydrated = (state: AllPromotionState) => state[REDUCER_NAME]?.thunderbite?.isHydrated;
export const selectThunderbiteIsPolling = (state: AllPromotionState) => state[REDUCER_NAME]?.thunderbite?.isPolling;
export const selectThunderbiteError = (state: AllPromotionState) => state[REDUCER_NAME]?.thunderbite?.error;
